import GooglePlacesAutocomplete from 'react-google-places-autocomplete';
// If you want to use the provided css
//import 'react-google-places-autocomplete/dist/index.min.css';// import { geocodeByAddress } from 'react-google-places-autocomplete';
import { geocodeByAddress, getLatLng } from 'react-google-places-autocomplete';

import React, { Component } from 'react'

export default class LocationAutoComplete extends Component {

    getLatLng=(name)=>{
        // // console.log(name.description);
        
        // geocodeByAddress(name.description)
        // .then(results => console.log(results[0]))
        // .catch(error => console.error(error));

        geocodeByAddress(name.description)
        .then(results => getLatLng(results[0]))
        .then(({ lat, lng }) =>
            console.log('Successfully got latitude and longitude', { lat, lng })
        );


    }
    render() {
        return (
            <div>
                <GooglePlacesAutocomplete
                    onSelect={(val)=>this.getLatLng(val)}
                    autocompletionRequest={{
                        location:"",
                        componentRestrictions:{
                            country: ['qa'],
                            }
                        }}
                        
                />
            </div>
        )
    }
}
